import axios from 'axios'
import { TokenService } from '../token-service/token-service'
import { useHistory } from 'react-router-dom'
import { ROUTE_CONSTANTS } from '../../constants/RouteConstants'
import { ToasterService } from '../toaster-service/toaster-service'
import { HTTP_RESPONSE } from '../../enums/http-responses.enum'
import { CONSTANTS } from '../../constants/Constants'
 
const baseUrl = `${process.env.REACT_APP_API_BASEURL}`
// const baseUrl = "http://4.247.183.76:8000/"
const apiKey = 'pcQTh0BhiY1PCVgDfjEOR5yVXj3p8GhL90m6pzmA'
 
export let axiosInstance: any
// eslint-disable-next-line prefer-const
axiosInstance = axios.create({
  baseURL: baseUrl,
})
axiosInstance.defaults.headers.common['x-api-key'] = apiKey
axiosInstance.interceptors.request.use(
  (config: any) => {
    const token = TokenService().getAccessToken()
    const workspaceId = document.cookie
      .split('; ')
      .find((row) => row.startsWith('workspaceId='))
      ?.split('=')[1];
    const environmentId = localStorage.getItem('environmentId')
    // const environmentId = document.cookie
    //   .split('; ')
    //   .find((row) => row.startsWith('environmentId='))
    //   ?.split('=')[1];

    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    const domain = TokenService().getDomain()
    if (domain) {
      config.headers['x-subdomain'] = domain
    }
    const origin = TokenService().getOrigin()
    if (origin) {
      config.headers['x-origin'] = origin
    }
    if (workspaceId) {
      config.headers['workspaceid'] = workspaceId;
    }
    if (environmentId) {
      config.headers['environmentid'] = environmentId;
    }
    return config
  },
  (error: any) => {
    Promise.reject(error)
  }
)
 
axiosInstance.interceptors.response.use(
  (response: any) => {
    return response
  },
  (error: any) => {
    if (
      error?.response?.data?.message &&
      typeof error?.response?.data?.message === 'string'
    ) {
      console.log('error', error?.response?.data?.message)
      ToasterService.show(error?.response?.data?.message, CONSTANTS.ERROR)
    }
    if (error?.response?.status === HTTP_RESPONSE.UNAUTHORIZED) {
      useHistory().replace(ROUTE_CONSTANTS.LOGIN)
    }
    return Promise.reject(error)
  }
)
